import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { B2BUser, SemanticPathService, UserIdService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { filter, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EfaTermsAndConditionsGuard {
  constructor(
    protected semanticPathService: SemanticPathService,
    protected userFacade: UserAccountFacade,
    protected router: Router,
    protected userIdService: UserIdService,
  ) {}

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.userIdService.takeUserId(true).pipe(
      // A two-step retrieval is used for the current user in order to get its updated value from the backend and avoid using its cached value.
      switchMap((userId: string) => this.userFacade.getById(userId)),
      filter(Boolean),
      switchMap((user: B2BUser) => {
        if (!user.termsAccepted) {
          return of(
            this.router.parseUrl(
              this.semanticPathService.get('termsAndConditionsConfirmation'),
            ),
          );
        } else {
          return of(true);
        }
      }),
    );
  }
}
